export const WORKSPACE_DATA_TAB_QUERY_VALUE = 'data';

export const WORKSPACE_EXPORT_POLL_INTERVAL_MILLISECONDS = 5000;
export const WORKSPACE_EXPORT_NOT_FOUND_ERROR_CODE = 'workspace_export.not_found';

export const WORKSPACE_CLOSURE_GRACE_DAYS = 14;

export const WORKSPACE_EXPORT_STATUS = {
  pending: 'pending',
  building: 'building',
  ready: 'ready',
  failed: 'failed',
  expired: 'expired',
} as const;
